import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskNotificationsInternalNotificationsRoute: InvariantJiraRoute =
	{
		name: 'project-settings-servicedesk-notifications-internal-notifications',
		path: '/jira/servicedesk/projects/:projectKey/settings/notifications/internal-notifications',
	};
